var React = require('react');

function Hamburger2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.857178 5.14285H18V6.85713H0.857178V5.14285Z","fill":"#98988A","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.857178 0H18V1.71429H0.857178V0Z","fill":"#98988A","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.857178 10.2857H12.8572V12H0.857178V10.2857Z","fill":"#98988A","key":2})]);
}

Hamburger2.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = Hamburger2;

Hamburger2.default = Hamburger2;
